import React, {useState} from 'react';
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Nav,
    NavLink,
    TabContent,
    TabPane,
  } from "reactstrap";
import {TAB_DEALER, TAB_GENERAL, TAB_NOTARY, TAB_SERVICES} from '../../../constants/company';
import { isMobile } from 'react-device-detect';
import classnames from "classnames";
import Accordion from "../Accordion";
import { AccordionCategoryType } from '../../../Interfaces/shared';

const FAQWrapper = ({ initialTab }: {initialTab: AccordionCategoryType}) => {

  const [activeTab, setactiveTab] = useState(initialTab);

  return (<section className="section faq-section">
    <div className="faq-header text-center mb-5">
      <div className="small-title">FAQs</div>
      <h4 className='faq-title'>Frequently asked questions</h4>
      {isMobile && <hr className="horizontal-line"/>}
    </div>
    <Container>
      <Row>
        <Col lg="12">
          <div className="vertical-nav faqs-container">
            <Row>
              <Col lg="2" sm="4">
                <Nav pills className="flex-column">
                  <NavLink
                    className={classnames({ active: activeTab === TAB_GENERAL })}
                    onClick={() => {
                      setactiveTab(TAB_GENERAL)
                    }}
                  >
                    <i className="mdi mdi-help-circle-outline nav-icon d-block"/>
                    <p className="font-weight-bold mb-0 title">
                      General Questions
                    </p>
                  </NavLink>

                  <NavLink
                    className={classnames({ active: activeTab === TAB_SERVICES })}
                    onClick={() => {
                      setactiveTab(TAB_SERVICES)
                    }}
                  >
                    <i className="mdi mdi-cog-outline nav-icon d-block"/>
                    <p className="font-weight-bold mb-0 title">
                      Services
                    </p>
                  </NavLink>

                  <NavLink
                    className={classnames({ active: activeTab === TAB_DEALER })}
                    onClick={() => {
                      setactiveTab(TAB_DEALER)
                    }}
                  >
                    <i className='mdi mdi-car-key d-block nav-icon'/>
                    <p className="font-weight-bold mb-0 title">Dealers</p>
                  </NavLink>

                  <NavLink
                    className={classnames({ active: activeTab === TAB_NOTARY })}
                    onClick={() => {
                      setactiveTab(TAB_NOTARY)
                    }}
                  >
                    <i className="mdi mdi-stamper d-block nav-icon"/>
                    <p className="font-weight-bold mb-0 title">Notaries</p>
                  </NavLink>
                </Nav>
              </Col>
              <Col lg="10" sm="8">
                <Card>
                  <CardBody>
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId={TAB_GENERAL} id="buy">
                        <h4 className="card-title mb-4">
                          General Questions
                        </h4>

                        {/* accordion */}
                        <Accordion category={activeTab}/>
                      </TabPane>

                      <TabPane tabId={TAB_SERVICES}>
                        <h4 className="card-title mb-4">Services</h4>

                        <Accordion category={activeTab}/>
                      </TabPane>

                      <TabPane tabId={TAB_DEALER}>
                        <h4 className="card-title mb-4">Dealers</h4>

                        <Accordion category={activeTab}/>
                      </TabPane>

                      <TabPane tabId={TAB_NOTARY}>
                        <h4 className="card-title mb-4">Notaries</h4>

                        <Accordion category={activeTab}/>
                      </TabPane>
                    </TabContent>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  </section>
  )
}

export default FAQWrapper;
